// Agathist Studios — minimal theme JS
(function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.nav-toggle');
  var header = document.querySelector('.site-header');
  if (toggle && header) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Sticky header shadow on scroll
  if (header && header.dataset.sticky === 'true') {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // Sync variant radios -> hidden select on product page
  var form = document.querySelector('.product__form');
  if (form) {
    var select = form.querySelector('.product__variant-select');
    var radios = form.querySelectorAll('input[type="radio"]');
    function updateVariant() {
      var chosen = [];
      form.querySelectorAll('.product__option').forEach(function (opt) {
        var checked = opt.querySelector('input:checked');
        if (checked) chosen.push(checked.value);
      });
      if (!select) return;
      Array.prototype.forEach.call(select.options, function (o) {
        if (o.text.split(' – ')[0] === chosen.join(' / ')) select.value = o.value;
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', updateVariant); });
  }
})();
